import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {NewsService} from '../../../shared/services/news.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {NewsViewModel} from '../../../shared/viewModels/news.viewModel';
import {Constants} from '../../../shared/config/constants.config';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-news-single',
    templateUrl: './news-single.component.html',
    styleUrls: ['./news-single.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsSingleComponent implements OnInit {
    news: NewsViewModel;

    carouselOption1 = {
        loop: true,
        margin: 10,
        items: 1,
        nav: false,
        autoplay: true,
        autoplayTimeout: 3500,
        navText: ['<i class=\'ti-angle-left\'></i>', '<i class=\'ti-angle-right\'></i>']
    };

    constructor(
        private readonly newsService: NewsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly route: ActivatedRoute,
        private readonly constants: Constants,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.route.params.subscribe(params => {
            this.newsService.getSingleNews(params['id']).subscribe(news => {
                this.news = news;

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.markForCheck();
            });
        });
    }


}
